var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 6.5,
    stroke: "#B4B4B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5776C13 15.7063 13.7063 15 14.5776 15H35.0859C35.9572 15 36.6635 15.7063 36.6635 16.5776V16.5776C36.6635 17.4488 35.9572 18.1551 35.0859 18.1551H14.5776C13.7063 18.1551 13 17.4488 13 16.5776V16.5776ZM13 24.4654C13 23.5941 13.7063 22.8878 14.5776 22.8878H35.0859C35.9572 22.8878 36.6635 23.5941 36.6635 24.4654V24.4654C36.6635 25.3367 35.9572 26.043 35.0859 26.043H14.5776C13.7063 26.043 13 25.3367 13 24.4654V24.4654ZM13 32.3532C13 31.4819 13.7063 30.7756 14.5776 30.7756H35.0859C35.9572 30.7756 36.6635 31.4819 36.6635 32.3532V32.3532C36.6635 33.2245 35.9572 33.9308 35.0859 33.9308H14.5776C13.7063 33.9308 13 33.2245 13 32.3532V32.3532Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.850730bebf770a8fd0cee8c4ee42c58f.svg";
export { ForwardRef as ReactComponent };